// extracted by mini-css-extract-plugin
export default {"inner-layout":"ContentBody_inner-layout__xOyk1","liner-style":"ContentBody_liner-style__opNrb","card-hover":"ContentBody_card-hover__YkR-V"};